import { HttpClient, HttpEventType } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';
import * as _ from 'lodash';
import moment from 'moment';
import { environment } from 'src/environments/environment';
import * as XLSX from "xlsx";
import { ConstantConfig } from '../config/constant.config';
import { LoaderService } from '../services/loader.service';
/**
 * Represents a saved filter object where each key maps to an array of strings.
 */
export type SavedFilter = { [key: string]: string[] };

@Injectable({ providedIn: 'root' })
export class Utility {
  // Optional static loader service to be used by static methods
  static loaderService?: LoaderService;
  static httpClient?: HttpClient;

  constructor(    
    private loaderService: LoaderService,
    private httpClient: HttpClient,
  ) { 
    // Set injected services to static properties for backward compatibility.
    Utility.loaderService = loaderService;
    Utility.httpClient = httpClient;
  }
  
    static getErrorMessage(err:any){
        let errorMsg = [err];
        if(_.isPlainObject(err?.errors)){
            errorMsg = _.chain(err?.errors)?.values()?.flatten()?.value();
        }

        const msgList = errorMsg?.map((msg)=>{
         return  _.isString(msg) ? Utility.getPlainMessageTmpl(msg) :  Utility.getMessageTmpl(msg);
        });
        return msgList;
    }

    static getMessageTmpl(err:any){
      let errorMsg = `<div>`;
      if(err?.code){
         errorMsg += `<div>Error Code:${err?.code}</div>`;
      }
      if(err?.message){
        errorMsg += `<div>${err?.message}</div>`;
      }
      errorMsg += `<div>Please contact support for further assistance.</div>`;
      errorMsg += `</div>`;
      return errorMsg;
  }

  static getPlainMessageTmpl(msg:any){
    let errorMsg = `<div>`;
    errorMsg += `<div>${msg}</div>`;
    errorMsg += `</div>`;
    return errorMsg;
}
    static isValueEqual(value1:any , value2:any) : boolean{
      return (value1 === value2);
  }

  static getAgeInYrs(dt:string){
    const dob = new Date(dt);

    //calculate month difference from current date in time
    const month_diff = Date.now() - dob.getTime();
    //convert the calculated difference in date format
    const age_dt = new Date(month_diff);
    //extract year from date
    const year = age_dt.getUTCFullYear();
    //now calculate the age of the user
    const age = Math.abs(year - 1970);
    return age;
  }


  static getAgeInYrsWithDecease(dt:string,dt2:string){
    const dob = new Date(dt);
    const dec = new Date(dt2);
    //calculate month difference from current date in time
    const month_diff = ['',null,undefined].includes(dt2)?(Date.now() - dob.getTime()):(dec.getTime()-dob.getTime());
    //convert the calculated difference in date format
    const age_dt = new Date(month_diff);
    //extract year from date
    const year = age_dt.getUTCFullYear();
    //now calculate the age of the user
    const age = Math.abs(year - 1970);
    return Number.isNaN(age)?'':age;
  }


  /**
   * Export JSON Array to excel
   * @param name
   * @returns
   */
  static getFileName(name: string) {
    let timeSpan = new Date().toISOString();
    let sheetName = name || "report";
    let fileName = `${sheetName}-${timeSpan}`;
    return {
      sheetName,
      fileName
    };
  };
  static exportArrayToExcel(arr: any[], name: string = '') {
    let { sheetName, fileName } = Utility.getFileName(name);

    var wb = XLSX.utils.book_new();
    var ws = XLSX.utils.json_to_sheet(arr);
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  }

  static exportURLToExcel(metaInfo:any, name: string = '') {
    let { sheetName, fileName } = Utility.getFileName(name);
    //to download
    const a = document.createElement("a");
    a.href = metaInfo?.url;
    a.download = fileName;
    a.click();

  }

  static  async downloadURI(uri:any, name:string='') {
    Utility.loaderService?.showLoader();
    try {
      if (!Utility.httpClient) {
        throw new Error('HttpClient is not initialized for Utility.downloadURI');
      }

      await new Promise<void>((resolve, reject) => {
        Utility.httpClient?.get(uri, {
          observe: 'events',
          reportProgress: true,
          responseType: 'blob'
        }).subscribe({
          next: (event) => {
            if (event.type === HttpEventType.DownloadProgress) {
              return;
            }

            if (event.type === HttpEventType.Response) {
              const blob = new Blob([event.body as BlobPart], {
                type: event.body?.type || 'application/octet-stream'
              });
              saveAs(blob, name);
              resolve();
            }
          },
          error: reject
        });
      });
    } finally {
      Utility.loaderService?.hideLoader();
    }
  }

  static downloadFileFromURL(url:string, fileName: string) {
    saveAs(url,fileName);
  }

  static getRandomColor(){
    return '#'+(0x1000000+Math.random()*0xffffff).toString(16).substr(1,6);
  }

  static ROUNDUP(number:any, digits:any) {
    number = parseFloat(number);
    digits = parseFloat(digits);
    const sign = number > 0 ? 1 : -1
    return (sign * Math.ceil(Math.abs(number) * Math.pow(10, digits))) / Math.pow(10, digits);
  }

 static conver_To_Camel_Case(str:string)
  {
    let STR = str.toLowerCase()
		.trim()
		.split(' ')
		.map(word => word.replace(word[0], word[0].toString().toUpperCase()))
		.join(' ');
	return STR;
  }

 static getDefaultCategoryObject(catArr:any)
  {
  return catArr.find((item:any)=> item.is_default=='YES');
  }

 static isCategoryObjectIndexExist(catArr:any,id:number)
  {
  return catArr.map((item:any)=>item.id).indexOf(id);
  }

  static initialOfString(str:string)
  {

     let matches = str.match(/\b(\w)/g); // ['J','S','O','N']
     return matches?.join(''); // JSON

  }

  static getNextVersion(versionList:any)
  {

    let tbdList=versionList?.filter((item:any)=>{return item.version_status==='DRAFT'});
    let activeList=versionList?.filter((item:any)=>{return item.version_status==='ACTIVE'});
    tbdList.reverse();
    if(tbdList?.length>0)
    {
    return  tbdList[0].id;
    }
    else if(activeList.length>0)
    {
    return  activeList[0].id;
    }
    else
    {
      return -1;
    }

  }

  static getDType(tString:any) {
    if(tString===null || tString===undefined || tString===''){
      if(tString?.match(/^([0-9]*)$/)){
        return 'integer';
      }else if(tString?.match(/^[+-]?([0-9]*[.])?[0-9]+$/)){
        return 'float';
      }else if(tString?.match(/^\d{2}\/\d{2}\/\d{4}$/) || tString?.match(/^\d{2}\/\d{2}\/\d{2}$/) || tString?.match(/^\d{1}\/\d{1}\/\d{4}$/) || tString?.match(/^\d{1}\/\d{1}\/\d{2}$/) || tString?.match(/^\d{1}\/\d{2}\/\d{2}$/) || tString?.match(/^\d{1}\/\d{2}\/\d{4}$/)){
        return 'date';
      }else if(['TRUE','FALSE','true','false','yes','no','YES','NO'].includes(tString)){
        return 'boolean';
      }else{
        return "string";
      }
    }
    else
      return "string";
  }

  static getParamsFromObject(obj: Record<string, any>): string {
    const params = Object.entries(obj)
      .filter(([_, value]) => Boolean(value))
      .map(([key, value]) =>
        `${(key)}=${(String(value))}`
      )
      .join('&');
    return params;
  }
 
  static updateSavedFilter(
    savedFilter: SavedFilter,
    key: string,
    value: string | string[] | null,
    action: 'add' | 'delete' = 'add'
  ): SavedFilter {
    if (!savedFilter) {
      savedFilter = {};
    }

    if (action === 'delete') {
      if (key in savedFilter) {
        delete savedFilter[key];
      }
      return savedFilter;
    }

    if (!value) return savedFilter;

    const valuesToSet = Array.isArray(value) ? value : [value];

    // Always replace values for the given key
    savedFilter[key] = valuesToSet;

    return savedFilter;
  }  
  
  static getErrorList(err: any) {
    let errorMsg = [err];
    if (err?.errors) {
      if (_.isPlainObject(err?.errors)) {
        errorMsg = _.chain(err?.errors)?.values()?.flatten()?.value();
      }
      const msgList = errorMsg?.map((msg) => {
        return msg;
      });
      return msgList;
    } else if (err?.message) {
      return [err?.message];
    } else {
      return;
    }
  }

  static getOTPConfig(){
    return {
      allowNumbersOnly: true,
      length: 6,
      disableAutoFocus: false
    };
  }

  static getHumanDiffBetween(updatedAt: Date | string): string {
    return moment(updatedAt).fromNow();
  }

  static isFutureDate(date: string | Date): boolean {//return ture when date is today or future
    if (!date) return false;
    const cDate = moment(new Date()).format("YYYY-MM-DD");
    const sDate = moment(date).format("YYYY-MM-DD");
    return sDate >= cDate;
  }

  static filterSideNoteList(arr:any): any {
    let sortedArr = _.sortBy(arr, ['slug'], ['asc']);
    let currentDate = moment(new Date())?.tz(ConstantConfig.SERVER_TIMEZONE).format('YYYY-MM-DD');
    return sortedArr.filter((item:any) => (item.type == 'CPI' && item.activation_date <= currentDate) || (item.type != 'CPI' && item.status != 'IN-ACTIVE' && item.activation_date <= currentDate));
  }

  static formatSlug(slug: string): string {
    if (!slug) return '';
    if (slug === 'CPI') {
      return 'CPI';
    }
    return slug
      .toLowerCase()
      .replace(/_/g, ' ') // Replace underscores with spaces
      .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize first letter of each word
  }

  static getLoginAsClientUserPrefix(){
    return 'lendisoft_employee_';
  }

  static cleanObject(obj:any) {
    return Object.keys(obj).reduce((acc: any, key: string) => {
      const value = obj[key];
      if (![null,undefined,'']?.includes(value)) {
        acc[key] = value;
      }
      return acc;
    }, {});
  }


  static logFormControls(control: any, path: string = '') {
    if(!environment.production){
      console.log('form submit',control);
      if (control.controls && control.invalid) {
        Object.keys(control.controls).forEach(key => {
          const currentControl = control.controls[key];
          const controlPath = path ? `${path}.${key}` : key;
          if (currentControl.invalid) {
            console.log('Invalid Control:', controlPath, currentControl.errors);
          }
        });
      }
    }
  }

  static truncateMiddleFileName(name: string, maxLength: number = 35): string {
    if (!name || name.length <= maxLength) {
      return name;
    }

    const extensionIndex = name.lastIndexOf('.');
    const extension =
      extensionIndex !== -1 ? name.substring(extensionIndex) : '';

    const availableLength = maxLength - extension.length - 3;

    const startLength = Math.ceil(availableLength / 2);
    const endLength = Math.floor(availableLength / 2);

    const start = name.substring(0, startLength);
    const end = name.substring(
      name.length - extension.length - endLength,
      name.length - extension.length
    );

    return `${start}...${end}${extension}`;
  }
}
